<template>
  <div class="header">
    <img src="../assets/logo.png" class="logo">
  </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  height: 60px;
  text-align: left;
  background-color: #404854;
  padding: 0 30px;
  .logo {
    height: 30px;
  }
}
</style>
